/* eslint-disable no-nested-ternary */
import React, { useRef } from 'react'
import classNames from 'classnames'
import momonet from 'moment'
import { cdnImg } from 'meinian-package/src/utils/image'
import Icon from 'meinian-package/src/component/icon'
import CollectGroupBtn from 'publicComponent/collectGroupBtn'
import styles from './index.module.less'

const dealData = (num) => {
  /* if (num >= 1000000) {
    return `${(num / 1000000).toFixed(1)}m`
  } */
  if (num >= 10000) {
    return `${(num / 10000).toFixed(1)}w`
  }
  if (num >= 1000) {
    return `${(num / 1000).toFixed(1)}k`
  }
  return num
}

export default (props) => {
  const {
    minWidth,
    columnWidth,
    onClickCard,
    mainUrl,
    imageGroupEntityId,
    inspirationId,
    item = {},
  } = props
  const cardRef = useRef(null)
  const _insDataDTO = item?.insDataDTO || {}

  const infoHeight = 100
  return <div
    className={classNames(styles['meinian-waterfall-card-item'])}
    key={`${imageGroupEntityId}${inspirationId}`}
    style={{
      minWidth,
      width: columnWidth,
      height: props.width ? Math.round((columnWidth * props.height) / props.width) + infoHeight : columnWidth,
      display: 'flex',
      flexDirection: 'column'
    }}
  >
    <div
      className="meinian-waterfall-card-image"
      ref={cardRef}
      style={{ height: `calc(100% - ${infoHeight}px)` }}
      onClick={e => {
        window.open(`/df/detail/image?blogIds=${item.imageGroupEntityId}&unionIds=${item.unionId}&platformId=${item.platformId}`)
        onClickCard?.(item, e)
      }}
    >
      <div className="image-card-top-mask">
        <div className="image-card-top-btn">
          <CollectGroupBtn currentBlog={{ ...item, ..._insDataDTO }} />
        </div>
      </div>
      <img
        loading="lazy"
        src={cdnImg(mainUrl, 500)}
        style={{ width: '100%', height: '100%', objectFit: 'cover', background: 'linear-gradient(rgba(0,0,0,0.03), rgba(0,0,0,0.03))' }}
      />
    </div>
    <div className="info" style={{ height: infoHeight }}>
      <div className="avatar-title-wrap">
        <div
          className="name-wrap"
          onClick={() => {
            window.open(`/df/detail/blogger?sourceType=1&id=${_insDataDTO.bloggerId}`)
          }}
        >
          <img className="header-image" src={_insDataDTO.bloggerObj?.headImg} />
          <div className="title">{_insDataDTO.bloggerName}</div>
        </div>
        <div onClick={() => {
          _insDataDTO.blogUrl && window.open(_insDataDTO.blogUrl)
        }}
        >
          <Icon type="m-tiaozhuanyuanwen" className="title-link-icon" />
        </div>
      </div>
      <div className="card-num-row">
        <div>粉丝<span style={{ marginLeft: '4px' }}>{dealData(_insDataDTO?.bloggerObj?.fansNum)}</span></div>
        <div className="card-num-line" />
        <div>粉丝<span style={{ marginLeft: '4px' }}>{momonet(item.sourceTime).format('YYYY/MM/DD')}</span></div>
      </div>
      <div className="card-num-wrap">
        <div className="card-num-block">点赞<span className="card-num-block-num">{dealData(_insDataDTO.likeNum)}</span></div>
        <div className="card-num-block">评论<span className="card-num-block-num">{dealData(_insDataDTO.commentNum)}</span></div>
      </div>
    </div>
  </div>
}
